import { stdObject } from "../data/types/stdObject";
import { arrayToArrayObject } from "../utils/arrayToArrayObject";
import { arrayToObject } from "../utils/arrayToObject";
import { getPrefix } from "../utils/getPrefix";
import { sendData } from "./sendData";

export const callPersonItemInfo = async (
  modalInfo: stdObject,
  personItemField: Array<stdObject>,
  params: stdObject,
) => {
  const { logoutAction, countries, taxesList } = params;
  try {
    const payloadCallPersonItem = {
      type: modalInfo.doc,
      code: modalInfo.code,
    };
    console.log("payloadCallPersonItem", payloadCallPersonItem);
    const responseCallPersonItem: stdObject = await sendData({
      endPoint: modalInfo.doc === "ART" ? "callItem" : "callPerson",
      payload: payloadCallPersonItem,
      logoutAction,
    });
    console.log("responseCallPersonItem", responseCallPersonItem);
    const dataType = modalInfo.doc === "ART" ? "item" : "person";
    if (
      responseCallPersonItem.success &&
      responseCallPersonItem.status &&
      dataType in responseCallPersonItem
    ) {
      Object.keys(responseCallPersonItem[dataType]).forEach((e) => {
        responseCallPersonItem[dataType][
          e.endsWith(modalInfo.doc) ? getPrefix(e) : e
        ] = responseCallPersonItem[dataType][e];
        delete responseCallPersonItem[dataType][e];
      });
      let tempData: stdObject = {};
      personItemField.forEach((e) => {
        if (
          typeof e.CODPER === "string" &&
          e.CODPER in responseCallPersonItem[dataType]
        ) {
          tempData[e.CODPER] = responseCallPersonItem[dataType][e.CODPER];
        }
      });

      if (modalInfo.doc === "ART") {
        if (modalInfo.code === "") {
          responseCallPersonItem.taxes = [];
          countries
            .filter((e: stdObject) => e.ACTPAI === 1)
            .forEach((e: stdObject) => {
              responseCallPersonItem.taxes.push({
                IMPARI:
                  taxesList.find(
                    (v: stdObject) => v.CODIMP === e.CODPAI && v.PRIIMP,
                  )?.TARIMP ?? 0,
                PAIARI: e.CODPAI,
              });
            });
        }

        if (modalInfo.insertInDoc) {
          tempData.COD = modalInfo.insertInDoc;
        }

        tempData = {
          ...tempData,
          IMG: {
            code:
              typeof responseCallPersonItem.item.IMGU === "string" &&
              responseCallPersonItem.item.IMGU.length > 0
                ? responseCallPersonItem.item.IMGU
                : tempData.COD,
            images: responseCallPersonItem.images,
          },
          stock: responseCallPersonItem.stock,
          sizes: responseCallPersonItem.sizes,
          commissions: responseCallPersonItem.commissions,
          PRE: {
            cost: arrayToObject({
              key: "PAIPCO",
              erase: ["PAIPCO"],
              data: responseCallPersonItem.cost,
            }),
            prices: arrayToArrayObject({
              key: "PAILTA",
              subKey: "TARLTA",
              erase: ["ARTLTA", "PAILTA"],
              data: responseCallPersonItem.prices,
            }),
            taxes: arrayToObject({
              key: "PAIARI",
              erase: ["PAIARI"],
              data: responseCallPersonItem.taxes,
            }),
            offers: arrayToArrayObject({
              key: "PAIOFE",
              erase: ["ARTOFE", "PAIOFE"],
              data: responseCallPersonItem.offers,
            }),
            insurances: arrayToArrayObject({
              key: "PAIPS0",
              subKey: "PSEPS0",
              erase: ["CODPS0", "PAIPS0"],
              data: responseCallPersonItem.insurances,
            }),
          },
        };
        Object.keys(tempData.PRE.offers).forEach((e) => {
          tempData.PRE.offers[e] = tempData.PRE.offers[e].map(
            (v: stdObject) => {
              let newData: stdObject = {};
              if (Number(v.DATOFE) > 0) {
                newData.value = v.DAYSOFE;
              }
              switch (Number(v.DATOFE)) {
                case 1:
                  newData.key = "DATES";
                  break;
                case 2:
                  newData.key = "DAYS";
                  break;
                case 3:
                  newData.key = "WEEK";
                  break;
              }
              try {
                if (Number(v.DATOFE) > 0) {
                  newData.value = JSON.parse(newData.value);
                  if (!Array.isArray(newData.value)) {
                    newData.value = [];
                  }
                }
              } catch (error) {
                console.log("offers days error: ", error);
                newData.value = [];
              }
              if (v.TIPOFE) {
                v.POROFE = v.PREOFE;
                delete v.PREOFE;
              }
              return newData.key ? { ...v, [newData.key]: newData.value } : v;
            },
          );
        });
      } else {
        tempData = {
          ...tempData,
          DOM:
            responseCallPersonItem.address.length > 0
              ? responseCallPersonItem.address[0].DOMDIR
              : "",
        };
      }
      console.log("tempData", tempData);
      return { data: { ...tempData, insertInDoc: modalInfo.insertInDoc } };
    } else {
      return { error: responseCallPersonItem.error };
    }
  } catch (error) {
    console.log("callPersonItemInfo error: ", error);
    return { error: "error" };
  }
};
